import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Cliente } from '../models/cliente.model';
import { environment } from '../../../src/app/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {
  private apiUrl = `${environment.advContabilApi}/api/Cliente`;

  constructor(private http: HttpClient) {}

  getClientes(usuarioId: string): Observable<Cliente[]> {
    return this.http.get<Cliente[]>(`${this.apiUrl}/listar?usuarioId=${usuarioId}`);
  }

  getClienteById(id: number): Observable<Cliente> {
    return this.http.get<Cliente>(`${this.apiUrl}/Obter/${id}`);
  }

  addCliente(cliente: Cliente): Observable<Cliente> {
    return this.http.post<Cliente>(`${this.apiUrl}/Inserir`, cliente);
  }

  updateCliente(cliente: Cliente): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/Atualizar/${cliente.id}`, cliente);
  }

  deleteCliente(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/Deletar/${id}`);
  }
}
